import React from 'react';

import { Chip } from '@/widgets';

/**
 * @description Status badge for transaction
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @param {object} props
 *
 * @returns {React.ReactElement}
 */

export type TStatus =
	| 'COMPLETED'
	| 'APPROVED'
	| 'PENDING'
	| 'DEEMED'
	| 'INITIATED'
	| 'PROCESSING'
	| 'QUEUED'
	| 'ERRORED'
	| 'FAILED'
	| 'CANCELLED';

const getVariant = (status: TStatus) => {
	switch (status) {
		case 'COMPLETED':
		case 'APPROVED':
			return 'success';
		case 'PENDING':
		case 'DEEMED':
		case 'INITIATED':
		case 'PROCESSING':
		case 'QUEUED':
			return 'warning';
		case 'ERRORED':
		case 'FAILED':
		case 'CANCELLED':
			return 'error';
		default:
			return 'info';
	}
};

export default function TransactionStatus({
	status,
}: Readonly<{ status: TStatus }>) {
	return <Chip variant={getVariant(status)}>{status}</Chip>;
}
